import React from "react";
import styled from "styled-components";

import NavbarPrincipal from "./NavbarPrincipal";
import NavbarSuperior from "./NavbarSuperior";

const Container = styled.div`
  position: relative;
`;

const Navbar = () => {
  return (
    <Container>
      <NavbarSuperior />
      <NavbarPrincipal />
    </Container>
  );
};

export default Navbar;
